import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { useEffect, useState } from 'react';
import { useToast } from '../ui/use-toast';
import Image from 'next/image';
import SmartImage from '../SmartImage';

export default function MasterpassRemoveCardDialog({
  open,
  onOpenChange,
  cardCount,
  cardAlias,
  onRemoveAction,
  vCount,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  cardCount: number;
  cardAlias: string;
  onRemoveAction: (alias: string) => void;
  vCount: number;
}) {
  const { toast } = useToast();

  const [code, setCode] = useState('');

  useEffect(() => {
    setCode('');
  }, [open, vCount]);

  const aError = () => {
    toast({
      variant: 'destructive',
      description: 'Bir hata oluştu',
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-[425px]"
        onInteractOutside={(e) => {
          e.preventDefault();
        }}
      >
        <DialogHeader className="space-y-0">
          <div className="mb-5 text-center">
            <SmartImage
              className="inline"
              src="/masterpass.svg"
              alt="masterpass by mastercard"
              width={149}
              height={32}
              imageType="custom"
            />
          </div>
          <DialogTitle className="text-[32px] text-hzc_purple_500">Kart Silme</DialogTitle>
          <DialogDescription className="h-0"></DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2">
          <div className="text-start text-sm text-hzc_beige_900">
            {cardCount > 1 ? (
              <>
                <span className="font-medium">{cardAlias}</span> kartınızı Masterpass altyapısından
                silmek istediğinize emin misiniz?
              </>
            ) : (
              <>
                Son kartınızın silinmesi ile birlikte Masterpass hesabınız da silinecektir.
                Onaylıyor musunuz?
              </>
            )}
          </div>
        </div>
        <DialogFooter className="gap-2">
          <div className="flex flex-row gap-4 justify-end">
            <Button
              className="text-hzc_purple_500 bg-[#5E6AFF1A] hover:bg-[#5E6AFF1A] transition-all duration-300 hover:scale-105 rounded-full h-[48px] gap-2"
              onClick={() => onRemoveAction(cardAlias)}
            >
              Evet
            </Button>
            <Button
              className="text-hzc_beige_900 border-1 border-[#5E6AFF1A] bg-[#FFFFFF] hover:bg-[#FFFFFF] transition-all duration-300 hover:scale-105 rounded-full h-[48px]"
              onClick={() => onOpenChange(false)}
            >
              Hayır
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
